module.exports = __webpack_public_path__ + "media/images/challenges/golden-ticket-22/2016_professional_winner-500f8dead02104579964a0aa6c66607e.jpg";